export default {
  '500_title': 'Something goes wrong',
  '500_description':
    'This page was broken and our enginering noted and they working hard to fix it as soon as possible',
  '403_title': 'You don’t have permission to view this page',
  '403_description':
    'You can’t access this page based on the granted permissions, contact the admin for more information.',
  '404_title': 'Page not found',
  '404_description':
    'Sorry, There is no page with current URL ot it maybe replace onto another URL',
}
